import React from 'react'

interface ProbBarProps {
  prob: number | null | undefined
  marketProb?: number | null
  showLabel?: boolean
}

function barColor(p: number): string {
  if (p < 0.2) return 'var(--bad)'
  if (p < 0.4) return 'var(--warn)'
  if (p < 0.6) return 'var(--muted)'
  return 'var(--accent)'
}

export default function ProbBar({ prob, marketProb, showLabel = true }: ProbBarProps) {
  if (typeof prob !== 'number') {
    return (
      <div className="prob-bar">
        <div className="prob-bar-track">
          <div className="prob-bar-fill" style={{ width: 0 }} />
        </div>
        {showLabel && <span className="prob-bar-label muted">-</span>}
      </div>
    )
  }

  const pct = Math.max(0, Math.min(100, prob * 100))
  const color = barColor(prob)

  return (
    <div className="prob-bar">
      <div className="prob-bar-track">
        <div
          className="prob-bar-fill"
          style={{ width: `${pct}%`, backgroundColor: color }}
        />
        {typeof marketProb === 'number' && (
          <div
            className="prob-bar-marker"
            style={{ left: `${Math.max(0, Math.min(100, marketProb * 100))}%` }}
            title={`Market: ${(marketProb * 100).toFixed(1)}%`}
          />
        )}
      </div>
      {showLabel && (
        <span className="prob-bar-label">{pct.toFixed(0)}%</span>
      )}
    </div>
  )
}
